<template>
	<div class="open_face_register">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">开启人脸注册</h1>
		<h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			开启本地人脸注册流程。
		</p>
		<h3 class="doc_main_h3">函数</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">void __stdcall SKFaceStartRegisterPerson(int nModel, const char* pszName,
int nSex, int nYear, int nMonth, int nDay,
            const char* pszDetail, const char* pszGroup, 
            int nStartX,int nStartY, int nWidth, int nHeight,
            SKFaceRegPersonStateCallback funcRegisterPersonStateCallback,
            SKFaceRegisterProgressCallback funcRegisterProgressCallback);
</code></pre>
        <h3 class="doc_main_h3">注册人员属性参数</h3>
        <p class="doc_main_p">
        	（1）nModel：注册模式：0：快速注册（默认值）、1：标准注册、2：精准注册，其他值默认为0
        </p>
        <p class="doc_main_p">
        	（2）pszName：注册人员姓名(最长20个字符，仅支持汉字、字母、数字、下划线)
        </p>
        <p class="doc_main_p">
        	（3）nSex：注册人员性别（1：女，2：男，0：SDK识别出的性别）
        </p>
        <p class="doc_main_p">
        	（4）nYear：注册人员生日-年份（传入1900，为默认值，SDK识别出的年龄）
        </p>
        <p class="doc_main_p">
        	（5）nMonth：注册人员生日-月份（传入01，为默认值，SDK识别出的年龄）
        </p>
        <p class="doc_main_p">
        	（6）nDay：注册人员生日-几日（传入01，为默认值，SDK识别出的年龄）
        </p>
        <p class="doc_main_p">
        	（7）pszDetail：细节信息（其他备注信息，可为空）
        </p>
        <p class="doc_main_p">
        	（8）pszGroup：注册人员组ID（人员组id用“,”隔开，“”为默认值，例如：”2001，2002”，表示当前人员注册到人员组id为2001.2002的分组下，默认分组为当前终端所关联全部分组，没有关联人员组会创建一个新分组）
        </p>
        <h3 class="doc_main_h3">注册区域参数</h3>
        <p class="doc_main_p">
        	（1）nStartX：有效注册区域的起点坐标x值（请注意转换为分辨率对应值）
        </p>
        <p class="doc_main_p">
        	（2）nStartY：有效注册区域的起点坐标y值（请注意转换为分辨率对应值）
        </p>
        <p class="doc_main_p">
        	（3）nWidth：从(StartX, StartY)点向右nWidth为有效注册区域（请注意转换为分辨率对应值）
        </p>
        <p class="doc_main_p">
        	（4）nHeight：从(StartX, StartY)点向下nHeight为有效注册区域（请注意转换为分辨率对应值）
        </p>
		<h3 class="doc_main_h3">回调函数参数</h3>
		<p class="doc_main_p">
        	（1）funcRegisterPersonStateCallback类型为typedef void(__stdcall  *SKFaceRegPersonStateCallback)(int nCode,const char* pszMsg, const char* pszPersonInfo); nCode:状态码; pszMsg: 状态消息; pszPersonInfo: 注册成功的人员信息
        </p>
        <p class="doc_main_p">
        	（2）funcRegisterProgressCallback类型为typedef void(__stdcall *SKFaceRegProgressCallback)(const char *pszRegisterProgress ) ; pszRegisterProgress: 格式为37个int值(0/1)组成的数组json串 
        </p>
        <h3 class="doc_main_h3">返回值</h3>
        <p class="doc_main_p">
        	无
        </p>
        <h3 class="doc_main_h3">回调值</h3>
        <h4 class="doc_main_h4">注册状态回调结果列表</h4>
        <register-state-callback-table></register-state-callback-table>
        <h4 class="doc_main_h4">注册进度回调结果列表</h4>
        <register-progress-callback-table></register-progress-callback-table>
        <h3 class="doc_main_h3">示例代码</h3>
        <pre class="doc_main_pre"><code class="doc_main_code">// 注册状态回调函数
void __stdcall FuncRegisterState(int nCode,const char *pszMsg, const char *pszPersonInfo)
{
    printf("RegisterStateCallback: code = %d, msg = %s, personInfo=%s\n", nCode, pszMsg,pszPersonInfo);
}
// 注册进度回调函数
void __stdcall FuncRegisterProgress(const char* pszProgress)
{
    printf("RegisterProgressCallback: progress=%s",pszProgress);
}
// 调用注册函数进行注册
SKFaceStartRegisterPerson(0, "张丹", 1, 1900, 01, 
      01, "", "", 0, 0, 1920, 1080, FuncRegisterState, FuncRegisterProgress);
</code></pre>
	</div>
</template>
<script>
	import DocumentTitleBar from '../../../../components/documentTitleBar';
	import RegisterStateCallbackTable from '../../../../components/registerStateCallbackTable'
	import RegisterProgressCallbackTable from '../../../../components/registerProgressCallbackTable'
	export default{
		components:{
			'document-title-bar':DocumentTitleBar,//引入顶部面包屑导航
			'register-state-callback-table':RegisterStateCallbackTable,//引入注册状态列表
			'register-progress-callback-table':RegisterProgressCallbackTable,//引入注册进度列表
		},
		data(){
			return{
				isPathData:['人脸识别','SKFaceLive-Windows','本地接口','开启人脸注册'],
			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../../less/index.less';
	.open_face_register{
	}
</style>	



// WEBPACK FOOTER //
// src/views/documents/skfacelivewindows/localface/openFaceRegister.vue